import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const CeleparService = {
    renavam: async (formData) => axios.post(API_URL + "/celeparRenavam/search", formData).then(({data}) => data).catch((err) => { throw err }),

    driver: async (formData) => axios.post(API_URL + "/celeparDriver/search", formData).then(({data}) => data).catch((err) => { throw err }),
};

export default CeleparService;